export function trackPendoEvent(eventName: string, properties?: Record<string, any>): void {
  const w = window as any;
  if (w.pendo?.track) {
    w.pendo.track(eventName, properties ?? {});
  }
}
